var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIbmSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1251 17.2412L13.4051 12.5212C14.5393 11.1595 15.1049 9.413 14.9842 7.64498C14.8635 5.87695 14.0658 4.22351 12.7571 3.02863C11.4483 1.83375 9.72934 1.18942 7.95765 1.22968C6.18597 1.26994 4.498 1.99169 3.24491 3.24479C1.99182 4.49788 1.27007 6.18584 1.22981 7.95753C1.18955 9.72922 1.83388 11.4482 3.02875 12.7569C4.22363 14.0657 5.87707 14.8633 7.6451 14.984C9.41313 15.1047 11.1596 14.5392 12.5213 13.405L17.2413 18.125L18.1251 17.2412ZM2.50015 8.12503C2.50015 7.01251 2.83005 5.92497 3.44813 4.99994C4.06621 4.07492 4.94472 3.35395 5.97255 2.9282C7.00039 2.50246 8.13139 2.39107 9.22253 2.60811C10.3137 2.82515 11.316 3.36088 12.1026 4.14755C12.8893 4.93422 13.425 5.9365 13.6421 7.02764C13.8591 8.11879 13.7477 9.24979 13.322 10.2776C12.8962 11.3055 12.1753 12.184 11.2502 12.802C10.3252 13.4201 9.23767 13.75 8.12515 13.75C6.63381 13.7484 5.20403 13.1552 4.1495 12.1007C3.09497 11.0461 2.5018 9.61636 2.50015 8.12503Z",
    fill: "#868E96"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIbmSearch);
export default __webpack_public_path__ + "static/media/IBMSearch.c9444035.svg";
export { ForwardRef as ReactComponent };